import { Link } from 'react-router-dom';
import { Block, ErrorNote, Loading, Row, Screen } from '../components/primitives';
import { GuidancePanel } from '../components/panels/guidance';
import { ALIGNMENT_AXES, alignmentBand } from '@mlm/shared/coaching';
import { apiErrorPayload, COACH_URL, coaching } from '../lib/api';
import { shareText } from '../lib/share';
import { shortDay } from '../lib/format';
import { useFeatureLocked, useGuidance, useInviteLink } from '../lib/queries';
import { ProLock } from '../components/pro-lock';

/** SC-28 simple view: today's theme from the member's own chart, framed as reflection. */
export function VedicPage() {
  const locked = useFeatureLocked('guidance');
  const guidance = useGuidance();
  const invite = useInviteLink();

  if (locked) {
    return (
      <Screen back="/align" eyebrow="Vedic guidance" title="Today's guidance is part of Pro">
        <ProLock feature="guidance" />
      </Screen>
    );
  }
  if (guidance.isPending) return <Loading label="Reading today's sky" />;
  if (guidance.isError) {
    if (apiErrorPayload(guidance.error)?.error === 'birth_details_required') {
      return (
        <Screen back="/align" eyebrow="Vedic guidance" title="Add your birth details">
          <Block
            action={
              <Link to="/settings" className="eyebrow underline underline-offset-4 hover:text-ink">
                Go to settings
              </Link>
            }
          >
            Guidance is written from your own chart, so it needs your birth date and place.
          </Block>
        </Screen>
      );
    }
    return <ErrorNote error={guidance.error} retry={() => void guidance.refetch()} />;
  }

  const g = guidance.data;
  return (
    <Screen
      back="/align"
      eyebrow={`Today's Vedic guidance · ${shortDay(g.day)}`}
      title={g.headline}
      subtitle={g.summary}
    >
      <GuidancePanel g={g} />
      <Row
        title="Share today’s guidance"
        meta="The headline and the four bands, with your invite link"
        onClick={() => {
          const bands = ALIGNMENT_AXES.map(
            ({ key, label }) => `${label}: ${alignmentBand(g.alignment[key])}`,
          ).join(' · ');
          void shareText({
            title: 'Today’s guidance',
            text: `${g.headline}\n${g.summary}\n${bands}`,
            url: invite ?? COACH_URL,
          }).then((outcome) => {
            if (outcome === 'shared' || outcome === 'copied')
              coaching.event('content_shared', { kind: 'guidance', how: outcome });
          });
        }}
      />
      <Row
        title="The words in your reading"
        meta="What a dasha, a nakshatra and a yoga are"
        to="/align/learn"
      />
    </Screen>
  );
}
